import { useMemo } from "react";
import { renderToString } from "react-dom/server";
import Chart from "react-apexcharts";

export default function ChartGraph(props) {
    const {
        data: dataSeries = [{ data: [0, 0] }],
        enabled = true,
        isResizing = false,
        csvExportCategoryName = "Category",
        tooltipComponent,
        showXAxisTooltip = true
    } = props;

    //console.log("dataSeries", dataSeries);

    /* let hasData = dataSeries[0].data.length > 0;
    const count = dataSeries[0].data.length;
    if (count === 2) hasData = dataSeries[0].data[0] !== 0 && dataSeries[0].data[1] !== 0; */

    const opts = useMemo(() => {
        const options = JSON.parse(JSON.stringify(defaultChartGraphOptions));

        if (!enabled) {
            options.colors = ["#4f5b6d"];
            options.stroke = { colors: ["#4f5b6d"] };
            options.markers = { colors: ["#4f5b6d"], strokeColors: "#4f5b6d" };
            options.grid = {
                borderColor: "#4f5b6d"
            };
            options.xaxis = {
                labels: { style: { colors: "#4f5b6d" } },
                axisBorder: { show: true, color: "#4f5b6d" },
                axisTicks: { show: true, color: "#4f5b6d" }
            };
            options.yaxis = { labels: { style: { colors: "#4f5b6d" } } };
            options.fill = { opacity: 1, type: "solid" };
        }

        // Disable animations during resize to prevent gradual animation bug
        if (isResizing) {
            options.chart.animations = { enabled: false };
        }

        // Set the dynamic CSV export category header
        if (!options.chart.toolbar.export) options.chart.toolbar.export = {};
        if (!options.chart.toolbar.export.csv) options.chart.toolbar.export.csv = {};
        options.chart.toolbar.export.csv.headerCategory = csvExportCategoryName;

        // Set the custom tooltip if provided
        if (tooltipComponent) {
            options.tooltip = {
                ...options.tooltip,
                custom: function (tooltipData) {
                    return renderToString(tooltipComponent(tooltipData));
                }
            };
        }

        // Configure X-axis tooltip visibility
        if (options.xaxis) {
            options.xaxis.tooltip = { enabled: showXAxisTooltip };
        }

        return options;
    }, [enabled, isResizing, csvExportCategoryName, tooltipComponent, showXAxisTooltip]);

    // Use data length as key component instead of Math.random() to reduce re-renders
    // but still force update when data changes
    const chartKey = useMemo(() => {
        const dataLength = dataSeries[0]?.data?.length || 0;
        const firstValue = dataSeries[0]?.data?.[0]?.[1] || 0; // Get y-value of first point
        return `chart-${dataLength}-${firstValue}`;
    }, [dataSeries]);

    return <Chart type="area" height="166" width="100%" options={opts} series={dataSeries} key={chartKey} />;
}

export const defaultChartGraphOptions = {
    colors: ["#1C3B5B"],
    fill: {
        opacity: 0.75,
        type: "gradient",
        gradient: {
            opacityFrom: 1,
            opacityTo: 1,
            colorStops: [
                { offset: 0, color: "#61BEFF", opacity: 0.5 },
                { offset: 50, color: "#0060CC", opacity: 0.4 },
                { offset: 100, color: "#001934", opacity: 0 }
            ]
        }
    },
    legend: {
        // position: "top",
        // horizontalAlign: "right",
        // offsetY: 15,
        // offsetX: 500,
        // labels: { colors: "#ffffff" }
        show: false
    },
    xaxis: {
        type: "datetime",
        tickAmount: 6,
        labels: {
            style: { colors: "#ffffff" },
            format: "dd MMM 'yy"
        }
    },
    yaxis: {
        min: 0,
        //max: 40,
        tickAmount: 5,
        labels: { style: { colors: "#ffffff" } }
    },
    tooltip: {
        enabled: true,
        x: { show: false }
    },
    chart: {
        height: "100%",
        type: "area",
        toolbar: {
            show: true,
            export: {
                csv: {
                    headerCategory: "Category"
                }
            }
        },
        stacked: true,
        animations: { enabled: true },
        // Disable automatic resize to prevent gradual animation bug
        redrawOnWindowResize: false,
        redrawOnParentResize: false
    },
    plotOptions: { bar: { horizontal: false, columnWidth: "55%", endingShape: "rounded" } },
    dataLabels: { enabled: false },
    grid: {
        show: true,
        borderColor: "rgba(255,255,255, .15)",
        xaxis: { lines: { show: true } },
        yaxis: { lines: { show: true } },
        padding: { top: -40, right: 20, bottom: 0, left: 10 }
    },
    stroke: { show: true, curve: "straight", width: 2, colors: ["#5DD3E0"] }
};
